// Exact role identifiers belong in access lists, requests and settings. Resolve
// the cabinet type only for fixed business rules (teacher/student/admin, etc.).
const baseRoles = new Map()

export const registerRoleBases = (roles = []) => {
  roles.forEach((item) => {
    const role = item?.role ?? item?.item_name
    if (role && item?.base_role) baseRoles.set(role, item.base_role)
  })
}

export const getBaseRole = (role) => baseRoles.get(role) ?? role

export const hasBaseRole = (roles = [], role) =>
  (roles ?? []).some((item) => getBaseRole(typeof item === 'string' ? item : item?.item_name) === role)
